import HistoricoDeCancelamentos from "./historicoDeCancelamentos";
import {connect} from "react-redux";

export default connect()(HistoricoDeCancelamentos)
